import { Component, HostListener, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { AuthServiceService } from "src/app/services/auth-service.service";
import { GsdRoles } from "src/app/enums/gsdRoles.enum";
import { Resolve } from '@angular/router';
import { UserRoles } from "src/app/enums/userRoles.enum";
import { EmployeeModel } from "src/app/Models/EmpCareerUser.model";
import { UserService } from "src/app/services/user.service";

@Component({
  selector: "app-landing",
  templateUrl: "./landingpage.component.html",
  styleUrls: ["./landing.component.css"],
})
export class LandingComponent implements OnInit {
  employeeId: number;
  employeeCareerUserDetails?: EmployeeModel;
  public loading = false;
  adminRole = 0;
  public backgroundColor = false;
  public username: string;
  public useremail: string;
  public role: string;
  canViewSideMenu = true;
  loader: boolean = true;
  accessForCMF: boolean = false;
  accessForKMS: boolean = true;
  constructor(
    public router: Router,
    private toastr: ToastrService,
    private auth: AuthServiceService,
    public userService: UserService
  ) { }


  ngOnInit() {
    setTimeout(() => {
      var roles = this.auth.getRole();
      if (roles.includes(GsdRoles.Leadership)) {
        this.accessForCMF = true;
      }

      if (roles.includes(UserRoles.Admin) || roles.includes(UserRoles.SuperAdmin) || roles.includes(UserRoles.ContentManager) || roles.includes(UserRoles.Viewer)) {
        this.accessForKMS = false;
      }
    }, 100);

    this.employeeId = parseInt(localStorage.getItem("Id"));
    const empCareerUserId = localStorage.getItem('EmpCareerUserID');
    const empCareerUserDetailsString = localStorage.getItem('empCareerUserDetails');
    if (empCareerUserId && empCareerUserDetailsString) {
      try {
        this.employeeCareerUserDetails = JSON.parse(empCareerUserDetailsString);
      } catch (error) {
        console.error('Error parsing empCareerUserDetails from localStorage:', error);
        this.setECPUserData();
      }
    }
    else {
      this.setECPUserData();
    }
    localStorage.setItem("proposalTabIndex", "0");
    setTimeout(() => {
      this.loader = false;
    }, 0);
  }

  setECPUserData() {
    this.auth.getEmpCareerUserInfo(this.employeeId).subscribe((empCareerModel) => {
      if (empCareerModel) {
        this.employeeCareerUserDetails = empCareerModel;
        this.userService.empCareerUserDetails.next(empCareerModel);
        localStorage.setItem('EmpCareerUserID', empCareerModel.userID.toString());
        localStorage.setItem('empCareerUserDetails', JSON.stringify(empCareerModel));
      }
    }, error => {
      localStorage.setItem('EmpCareerUserID', '0');
      localStorage.setItem('empCareerUserDetails', null);
    });
  }
  isLeadershipRole() {
    var roles = this.auth.getRole();
    return roles.includes(GsdRoles.Leadership);
  }


  pageNavigate(data) {
    //todo: make it switch case
    if (data === 'Competencies') {
      this.router.navigate(['Home/CMF Portal'])
    } else if (data === 'Sales') {
      this.router.navigate(['Home/KMSPortal'])
    } else if (data === 'Templates') {
      this.router.navigate(['Home/Artifactory Repository'])
    }
    else if (data === 'Dashboard') {
      this.router.navigate(['Home/Dashboard'])
    }
    else if (data === 'Skills') {
      this.router.navigate(['Home/Skill Repository'])
    }
    else if (data === 'customer-360') {
      this.router.navigate(['Home/Customer360'])
    }
    else if (data === 'Account') {
      this.toastr.info("Account Planning is coming soon. Stay tuned.")

    }
    else if (data === 'executiveDashboard') {
      this.router.navigate(['Home/Executive Dashboard'])
    }

    else {
      this.router.navigate(['Home/Proposal Repository']);
    }
  }
  isAuthorizedUser(value) {

    var roles = this.auth.getRole();
    if (
      roles.indexOf("SuperAdmin") >= 0 ||
      roles.indexOf(value + ".User") >= 0 ||
      roles.indexOf(value + ".Admin") >= 0
    ) {
      return true;
    } else {
      return false;
    }
  }
  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    $("#sidebar_r").removeClass("active");
    $("#sidebar").removeClass("active");
    $(".overlay").removeClass("active");
  }
  logout() {
    this.loading = true;
    localStorage.clear();
  }
}
